import React from "react";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Bars } from 'react-loader-spinner'



const Loader = () => {
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    // setTimeout(() => {
    //   setLoading(false);
    // }, 2000);
  }, []);

  return (
    <>

      {loading && (
        <div className="inner-loader">
            <Bars
              height="80"
              width="80"
              color="#2F024E"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
         
        </div>
      )}

    </>
  );
};

export default Loader;
